/** Русский язык. Падежи и множественное число намеренно обходятся формулировками вида «Монет: {n}». */
export const RU: Record<string, string> = {
  'ui.confirm': 'ОК',
  'ui.cancel': 'Отмена',
  'ui.close': 'Закрыть',
  'ui.back': 'Назад',
  'ui.level': 'Уровень',
  'ui.coins': 'Монеты',
  'ui.food': 'Еда',
  'ui.energy': 'Энергия',
  'ui.reputation': 'Слава',
  'ui.xp': 'Опыт',
  'ui.owned': 'Есть',
  'ui.locked': 'Закрыто',
  'ui.lvRequire': 'Откроется на ур. {lv}',
  'ui.buy': 'Купить',
  'ui.sell': 'Продать',
  'ui.sellAll': 'Продать всё',
  'ui.claim': 'Забрать',
  'ui.free': 'Бесплатно',
  'ui.max': 'Макс.',
  'ui.new': 'Новое!',
  'ui.lvShort': 'ур.',

  'start.title': 'Райский остров',
  'start.subtitle': 'Твой дом на море',
  'start.newGame': 'Новый остров',
  'start.continue': 'Продолжить',
  'start.namePrompt': 'Как зовут островитянина?',
  'start.defaultName': 'Островитянин',
  'start.slotEmpty': 'Пустой слот',
  'start.delete': 'Удалить',
  'start.deleteConfirm': 'Удалить это сохранение? Это нельзя отменить!',
  'start.tagline': 'Ферма · Рыбалка · Бои · Наряды · Друзья',
  'start.badge': 'Возвращение легенды',
  'start.headline': 'Нашумевшая игра вернулась с новой силой!',
  'start.lead': 'Построй остров мечты, выращивай урожай, лови редкую рыбу и зови друзей в гости.',
  'start.players': 'Уже более {n} игроков на островах',
  'start.features': 'Культур: {c} · Животных: {a} · Рыб: {f}',
  'start.slots': 'Выберите остров',

  'hud.bag': 'Сумка',
  'hud.shop': 'Магазин',
  'hud.quests': 'Задания',
  'hud.collections': 'Альбом',
  'hud.wardrobe': 'Наряды',
  'hud.neighbors': 'Друзья',
  'hud.edit': 'Декор',
  'hud.settings': 'Настройки',
  'hud.home': 'Домой',
  'hud.energyFull': 'Энергия полна',
  'hud.nextEnergy': '+1 через {t}',

  'act.till': 'Вспахать (монет: {coins})',
  'act.plant': 'Посадить',
  'act.water': 'Полить',
  'act.harvest': 'Собрать',
  'act.clear': 'Убрать',
  'act.removePlot': 'Убрать грядку',
  'act.feed': 'Кормить',
  'act.collect': 'Забрать',
  'act.fight': 'В бой!',
  'act.fish': 'Рыбачить',
  'act.weed': 'Выполоть',
  'act.pet.feed': 'Кормить (еды: 5)',
  'act.pet.play': 'Играть',
  'act.chase': 'Прогнать',
  'act.helpWater': 'Помочь с поливом',
  'act.prank': 'Подшутить',

  'panel.inventory': 'Сумка',
  'panel.shop': 'Островной магазин',
  'panel.quests': 'Журнал заданий',
  'panel.achievements': 'Достижения',
  'panel.daily': 'Ежедневные задания',
  'panel.tutorial': 'Путеводитель',
  'panel.collections': 'Коллекции',
  'panel.fishdex': 'Альбом рыб',
  'panel.beastdex': 'Альбом зверей',
  'panel.wardrobe': 'Гардероб',
  'panel.neighbors': 'Соседи',
  'panel.settings': 'Настройки',
  'panel.offline': 'Пока вас не было…',

  'shop.seeds': 'Семена',
  'shop.trees': 'Деревья',
  'shop.animals': 'Животные',
  'shop.buildings': 'Строить',
  'shop.clothing': 'Одежда',
  'shop.pets': 'Питомцы',
  'shop.tools': 'Инструменты',
  'shop.expand': 'Расширить остров',
  'shop.expandDesc': 'До {size}×{size} (нужен ур. {lv})',
  'shop.rod': 'Улучшить удочку',
  'shop.rodT1': 'Бамбуковая удочка',
  'shop.rodT2': 'Стеклопластиковая удочка',
  'shop.rodT3': 'Карбоновая удочка мастера',
  'shop.rodDesc': 'Хорошая удочка ловит более редкую рыбу',
  'shop.grow': 'Растёт: {t}',
  'shop.produce': 'Даёт продукт раз в {t}',
  'shop.feedCost': 'Корм: еды {n}',
  'shop.beauty': 'Красота +{n}',
  'shop.adoptName': 'Дайте имя:',

  'inv.empty': 'Сумка пуста — идите собирать урожай!',
  'inv.sellFor': 'Цена за штуку: {n}',

  'quest.done': 'Готово',
  'quest.progress': 'В процессе',
  'quest.reward': 'Награда',
  'quest.dailyRefresh': 'Обновляется в полночь',
  'quest.noneActive': 'Сейчас нет активных заданий',

  'dex.caught': 'Собрано {a}/{b}',
  'dex.unknown': '???',
  'dex.beastNote': 'Прогоняйте зверей, чтобы открыть записи',

  'wd.skin': 'Кожа',
  'wd.hair': 'Волосы',
  'wd.face': 'Лицо',
  'wd.top': 'Верх',
  'wd.bottom': 'Низ',
  'wd.hat': 'Шапка',
  'wd.accessory': 'Аксессуар',
  'wd.takeOff': 'Снять',

  'nb.friendship': 'Дружба',
  'nb.visit': 'В гости',
  'nb.hire': 'Нанять (монет: {coins})',
  'nb.hireDesc': 'Польёт, выполет сорняки и прогонит зверей за вас',
  'nb.helpLeft': 'Помощей сегодня осталось: {n}',
  'nb.prankLeft': 'Шалостей осталось: {n}',
  'nb.friendCode': 'Код друга',
  'nb.myCode': 'Скопировать код моего острова',
  'nb.visitCode': 'Вставить код друга',
  'nb.codeCopied': 'Код острова скопирован — поделитесь им!',
  'nb.codePrompt': 'Вставьте код острова друга:',
  'nb.codeBad': 'Не удалось прочитать код острова…',
  'nb.visiting': 'В гостях на острове: {name}',
  'nb.snapshotNote': 'Снимок острова: {name}',

  'fish.cast': 'Закинуть',
  'fish.wait': 'Ждём поклёвку…',
  'fish.bite': 'Клюёт! Жмите!',
  'fish.reel': 'Жмите, чтобы тянуть! Держитесь в зелёной зоне!',
  'fish.escaped': 'Сорвалась…',
  'fish.caught': 'Поймано: {name}!',
  'fish.newRecord': 'Новая запись в альбоме!',

  'battle.title': 'Прогоните: {name}!',
  'battle.hint': 'Жмите, когда указатель в зелёной зоне!',
  'battle.hit': 'Попадание!',
  'battle.crit': 'Критический удар!!',
  'battle.miss': 'Мимо… зверь дал отпор!',
  'battle.win': 'Победа! Получено монет: {coins}',
  'battle.flee': 'Отступить',

  'set.lang': 'Язык / Language / 语言',
  'set.sound': 'Звуковые эффекты',
  'set.music': 'Музыка',
  'set.export': 'Экспорт сохранения',
  'set.import': 'Импорт сохранения',
  'set.exportDone': 'Сохранение скопировано в буфер обмена',
  'set.importPrompt': 'Вставьте данные сохранения:',
  'set.importBad': 'Неверные данные сохранения',
  'set.importDone': 'Импортировано!',
  'set.reset': 'К заставке',
  'set.about': 'Об игре',

  'off.title': 'С возвращением, {name}!',
  'off.away': 'Вас не было: {t}',
  'off.crops': 'Созрело урожая: {n}',
  'off.animals': 'Готово продукции животных: {n}',
  'off.beasts': 'Зверей вторглось на остров: {n}!',
  'off.weeds': 'Выросло сорняков: {n}',
  'off.trampled': 'Потоптано растений: {n}…',
  'off.energy': 'Энергии восстановлено: {n}',
  'off.gift': 'Питомец принёс подарок: {name}',

  'tut.hint': 'Текущее задание',

  'msg.noEnergy': 'Не хватает энергии! Отдохните или повысьте уровень',
  'msg.noCoins': 'Не хватает монет',
  'msg.noFood': 'Не хватает еды — соберите урожай',
  'msg.noSeed': 'Нет семян этого вида — купите в магазине',
  'msg.noSpace': 'На острове нет места',
  'msg.needGrass': 'Вспахать можно только траву',
  'msg.occupied': 'Это место занято',
  'msg.weedHere': 'Сначала выполите сорняк',
  'msg.noPlot': 'Здесь нет грядки',
  'msg.plotBusy': 'Грядка уже засажена',
  'msg.noCrop': 'Грядка пуста',
  'msg.noNeedWater': 'Поливать пока не нужно',
  'msg.waterCd': 'Только что полито — подождите',
  'msg.notReady': 'Ещё не готово',
  'msg.notFound': 'Цель не найдена',
  'msg.notHungry': 'Оно не голодно',
  'msg.locked': 'Ещё не открыто',
  'msg.owned': 'Уже есть',
  'msg.notOwned': 'У вас этого нет',
  'msg.cannotPlace': 'Сюда нельзя поставить',
  'msg.cannotSell': 'Это нельзя продать',
  'msg.notEnough': 'Не хватает',
  'msg.maxRod': 'Удочка уже максимальная',
  'msg.maxIsland': 'Остров максимального размера',
  'msg.helpLimit': 'Сегодня помогать здесь больше нельзя',
  'msg.prankLimit': 'Сегодня шутить здесь больше нельзя',
  'msg.allClaimed': 'Все награды получены',
  'msg.cleared': 'Убрано',
  'msg.animalBought': 'Новый друг переехал к вам!',
  'msg.rodUpgraded': 'Удочка улучшена!',
  'msg.questReady': 'Задание готово к сдаче!',
  'msg.friendGift': 'Дружба выросла! {name} дарит вам монеты: {n}',
  'msg.hireDone': 'Сосед выполнил дел: {n}',
  'msg.levelUp': 'Уровень {lv}! Энергия полностью восстановлена!',
  'msg.saved': 'Сохранено',
  'msg.achievement': 'Достижение: {name}, ступень {tier}',
  'msg.beastArrive': 'Зверь вторгся на остров!',
  'msg.petGift': '{pet} принёс: {item}!',
  'msg.expanded': 'Остров расширен!',

  'hud.menu': 'Меню',
  'hud.leaderboard': 'Рейтинг',
  'hud.packs': 'Наборы',
  'panel.leaderboard': 'Рейтинг игроков',
  'panel.packs': 'Наборы',
  'lb.score': 'Заработано монет',
  'lb.you': '(вы)',
  'lb.rank': 'Ваше место: {rank} из {total}',
  'lb.hint': 'Продавайте урожай на рынке, чтобы подняться выше',
  'packs.hit': 'Хит',
  'packs.best': 'Выгодно',
  'packs.popular': 'Популярно',
  'packs.buy': 'Купить за {rub} ₽',
  'packs.coins': 'Монеты: {n}',
  'packs.food': 'Еда: {n}',
  'packs.xp': 'Опыт: {n}',
  'packs.energy': 'Полная энергия',
  'packs.rod': 'Лучшая удочка',
  'packs.island': 'Расширение острова: +{n}',
  'packs.clothing': 'Наряды: {list}',
  'packs.pets': 'Питомцы: {list}',
  'packs.animals': 'Животные: {list}',
  'packs.buildings': 'Постройки: {list}',
  'packs.sbp': 'Оплата через СБП: откроется приложение вашего банка. Набор придёт сразу после оплаты.',
  'packs.pending': 'Ожидаем оплату…',
  'packs.check': 'Проверить оплату',
  'packs.demo': 'Имитировать оплату (тест)',
  'packs.cancel': 'Отменить',
  'packs.thanks': 'Спасибо! Набор «{name}» получен',
  'packs.error': 'Не удалось: {msg}',
  'packs.unavailable': 'Оплата временно недоступна',
  'packs.notYet': 'Оплата ещё не поступила',
  'packs.canceled': 'Платёж отменён',
  'packs.compensated': 'Часть предметов не поместилась — вместо них начислены монеты: {n}',

  'hud.daily': 'Бонус',
  'hud.pass': 'Пропуск',
  'hud.more': 'Ещё',
  'hud.less': 'Скрыть',
  'daily.title': 'Ежедневная награда',
  'daily.streak': 'Серия входов: {n}',
  'daily.day': 'День {n}',
  'daily.claim': 'Забрать награду',
  'daily.claimed': 'Награда за сегодня получена',
  'daily.come': 'Возвращайтесь завтра: награда станет больше',
  'daily.reset': 'Пропустите день — серия начнётся заново',
  'daily.got': 'Награда получена: день {n}',
  'daily.x2': 'Событие «Награды ×2»: награда удвоена!',
  'pass.title': 'Сезонный пропуск',
  'pass.season': '{name} · ещё {n} дн.',
  'pass.tier': 'Уровень {n} из {max}',
  'pass.next': 'До следующего уровня: {n} очков',
  'pass.free': 'Бесплатно',
  'pass.premium': 'Премиум',
  'pass.claim': 'Забрать',
  'pass.claimAll': 'Забрать всё',
  'pass.locked': 'Закрыто',
  'pass.owned': 'Получено',
  'pass.buy': 'Открыть премиум за {rub} ₽',
  'pass.active': 'Премиум-пропуск активен',
  'pass.benefits': 'Премиум-награды на каждом уровне, а на уровнях 5, 10, 15, 20, 25 и 30 — эксклюзивные питомцы, наряды и постройки',
  'pass.points': 'Очки дают урожай, рыбалка, задания, победы над зверями и ежедневный бонус',
  'pass.reset': 'Каждый месяц — новый сезон; незабранные награды сгорают',
  'pass.got': 'Награда пропуска получена',
  'pass.nothing': 'Пока нечего забирать',
  'event.banner': '{icon} {name}: {desc} · ещё {t}',
  'packs.newbie': 'Только для новичков · осталось {t}',
  'packs.firstx2': '×2 монет за первую покупку',
  'packs.bought': 'Куплено',
  'packs.passNote': 'Пропуск открывается в разделе «Пропуск»',
  'packs.offerGone': 'Предложение для новичков недоступно',
  'lb.loading': 'Загружаем рейтинг…',
  'lb.offline': 'Рейтинг сейчас недоступен. Проверьте соединение',
  'lb.empty': 'Пока в рейтинге только вы. Продавайте урожай и станьте первым!',
  'lb.total': 'Игроков в рейтинге: {n}',
};
